import { DefaultPassThrough } from '@primevue/core'
import { CascadeSelectPassThroughOptions } from 'primevue/cascadeselect'
import type { CascadeSelectDesignTokens } from '@primeuix/themes/types/cascadeselect'
import CascadingDropdown from './CascadingDropdown.vue'

export const CascadeDropdownSinglePassthroughConfig: DefaultPassThrough<CascadeSelectPassThroughOptions> =
  {
    root: {
      class: '!tw-text-sm !tw-leading-tight tw-min-w-[60px]'
    },
    overlay: {
      id: 'tw-wrapper'
    },
    groupIconContainer: {
      class: '!tw-h-[140px]'
    },
    optionList: {
      class: '!tw-ml-[2px]'
    }
  }

export const CascadeDropdownSingleStyleConfig: CascadeSelectDesignTokens = {
  dropdown: {
    color: 'var(--color-text)',
    width: '2rem'
  },
  option: {
    padding: '4px 4px'
  }
}

export default CascadingDropdown
